import React from 'react';
import { PageHeader, Typography, Divider } from 'antd';
import { Table, Icon } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

const { Title, Paragraph, Text } = Typography;

const columns = [
  {
    title: 'Browser',
    dataIndex: 'browser',
    render: text => <Icon type={text} style={{ fontSize: '30px', }} />,
  },
  {
    title: 'Support',
    dataIndex: 'support',
  },

];

const data = [
  {
    key: '1',
    browser: 'ie',
    support: 'IE9이상의 버전에서 지원',
  },
  {
    key: '2',
    browser: 'chrome',
    support: '크롬 및 모든 모던 브라우저에서 지원',
  },
];

const routes = [
  {
    path: 'GettingStarted',
    breadcrumbName: 'Getting Started',
  },
];
const GettingStarted = () => {
  return (
    <>
      <PageHeader title="Getting Started" breadcrumb={{ routes }} subTitle="Getting Started" />
      <Typography style={{ padding: 20, paddingBottom: 0 }}>
        <Title>시작하기</Title>
        <br />
        <br />
        <br />
        <Title level={2}>이 페이지는 Mania FrameWork 문서 및 관련된 리소스 입니다.</Title><br /><br />
        <Paragraph>
          Documentation Page는 <Text code>React Hooks</Text>기반으로 제작되었으며,<br />
          회사 디자이너들이 코딩없이 쉽고 간편하게 사내 UI를 사용할 수 있게하려는 목적으로 제작 되었습니다.
          <br />
          <b>Documentation Page</b>에서 HTML 코드를 긁어서 붙혀 넣는 것 만으로도 UI 사용이 가능해집니다.
       </Paragraph>

        <Paragraph>
          <ul>
            <li>
              <a href="https://nodejs.org/ko/">Node v10.16.3</a>
            </li>
            <li>
              <a href="https://www.npmjs.com/">npm v6.9.0</a>
            </li>
          </ul>
        </Paragraph>

        <Divider />

        <Title level={2}>ManiaFrameWork 브라우저 지원</Title>
        <Paragraph>
          <Table columns={columns} dataSource={data} pagination={false} />
        </Paragraph>
        <Paragraph>
          <Text code>IE9</Text>이상의 버전 및 <Text code>크롬</Text>, <Text code>파이어폭스</Text> 등 모던브라우저에서 지원하며,
          반응형으로 제작되어 모바일에서도 깔끔하게 볼 수 있습니다.
        </Paragraph>

        <Divider />

        <Title level={2}>Mania FrameWork 사용하기</Title>
        <Paragraph>
          <Text code>CSS</Text>,  <Text code>JS</Text> 파일을 각각 HTML 상단과 하단에 위치시킵니다.
      </Paragraph>
      </Typography>
      <div style={{ padding: 20, paddingTop: 0 }}>
        <CodeHighlight language="HTML" >
          {`<!DOCTYPE html>
<html lang="ko-KR">
  <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta http-equiv="X-UA-Compatible" content="ie=edge">
      <title>ManiaFrameWork</title> 
      <link rel="stylesheet" type="text/css" href="./mania.css"> <!-- <<< Add-->
  </head>
  <body>
      <h1>Mania Framework</h1>
      <script src="./js/mania.js"></script> <!-- <<< Add-->
  </body>
</html>
`}
        </CodeHighlight>
      </div>

      <Typography style={{ padding: 20, paddingTop: 0 }}>
        <Divider />
        <Title level={2}>Documentation Page에서 원하는 UI 찾아쓰기</Title>
        <Paragraph>
          <Text code>HTML</Text>에 css, js 파일 불러오기를 완료 했다면,<br />
          Documentation Page에서 원하는 UI를 골라서 사용하시면 됩니다!
        </Paragraph>


      </Typography>,
    </>
  );
}

export default GettingStarted;
